import { Box, Spinner, Text } from "@chakra-ui/react";

interface PageLoaderProps {
  message?: string;
}

function PageLoader({ message = "Loading..." }: PageLoaderProps) {
  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bg="rgba(26, 32, 44, 0.9)"
      zIndex={9999}
    >
      <Spinner
        size="xl"
        color="brand.500"
        thickness="4px"
        speed="0.8s"
        emptyColor="gray.700"
      />
      <Text color="gray.300" mt={4} fontSize="lg">
        {message}
      </Text>
    </Box>
  );
}

export default PageLoader;
